import { render, staticRenderFns } from "./InstrumentFilter.vue?vue&type=template&id=87b80d76"
import script from "./InstrumentFilter.vue?vue&type=script&lang=ts"
export * from "./InstrumentFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports